import { QueryList, } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PlantHandlingInstructionsFormComponent, } from "./plant-handling-instructions-form/plant-handling-instructions-form.component";
import { asEnumerable } from "linq-es2015";
var PlantHandlingInstructionsComponent = /** @class */ (function () {
    function PlantHandlingInstructionsComponent() {
    }
    Object.defineProperty(PlantHandlingInstructionsComponent.prototype, "treatments", {
        get: function () {
            return this.experimentDesignFormGroup.get("treatments");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsComponent.prototype, "plantHandlingInstructions", {
        get: function () {
            return this.experimentDesignFormGroup.get("plantHandlingInstructions");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsComponent.prototype, "pesticidesAllowed", {
        get: function () {
            return this.experimentDesignFormGroup.get("pesticidesAllowed");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsComponent.prototype, "pesticidesAllowedAfterDays", {
        get: function () {
            return this.experimentDesignFormGroup.get("pesticidesAllowedAfterDays");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantHandlingInstructionsComponent.prototype, "pesticideLifeOfPlant", {
        get: function () {
            return this.experimentDesignFormGroup.get("pesticideLifeOfPlant");
        },
        enumerable: true,
        configurable: true
    });
    PlantHandlingInstructionsComponent.prototype.requiresNumberOfDays = function () {
        if (!this.pesticidesAllowed ||
            !this.plantHandlingOptions.pesticideInstructions) {
            return false;
        }
        var id = this.pesticidesAllowed.value;
        return !!this.plantHandlingOptions.pesticideInstructions.find(function (i) { return i.id === id && i.requiresNumberOfDays; });
    };
    PlantHandlingInstructionsComponent.prototype.ngOnInit = function () {
        var lightingInstructions = this.sortListByCeFlagAlphabetic(asEnumerable(this.ceRequestOptions.lightingInstructions));
        var humidityInstructions = this.sortListByCeFlagAlphabetic(asEnumerable(this.ceRequestOptions.humidityInstructions));
        var temperatureInstructions = this.sortListByCeFlagAlphabetic(asEnumerable(this.ceRequestOptions.temperatureInstructions));
        var pesticideInstructions = this.sortPesticidesByOrderNumber(asEnumerable(this.ceRequestOptions.pesticideInstructions));
        this.plantHandlingOptions = {
            lightingInstructions: lightingInstructions,
            humidityInstructions: humidityInstructions,
            temperatureInstructions: temperatureInstructions,
            pesticideInstructions: pesticideInstructions,
        };
    };
    PlantHandlingInstructionsComponent.prototype.applyAll = function (sourceComponent) {
        var args = {
            lighting: sourceComponent.lighting.value,
            temperature: sourceComponent.temperature.value,
            humidity: sourceComponent.humidity.value,
            imagingNeeded: sourceComponent.imagingNeeded.value
        };
        this.plantHandlingForms.forEach(function (f) { return f.copyValueFrom(args); });
    };
    PlantHandlingInstructionsComponent.prototype.sortListByCeFlagAlphabetic = function (list) {
        return list
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.requiresFollowup; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name,
            };
        })
            .ToArray();
    };
    PlantHandlingInstructionsComponent.prototype.sortPesticidesByOrderNumber = function (list) {
        return list
            .Where(function (s) { return s.isActive && s.id !== 2; })
            .OrderBy(function (s) { return s.orderNumber; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name,
                requiresNumberOfDays: s.requiresNumberOfDays,
            };
        })
            .ToArray();
    };
    return PlantHandlingInstructionsComponent;
}());
export { PlantHandlingInstructionsComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/plant-handling-instructions/plant-handling-instructions.component.ts.pre-build-optimizer.js